export const en = {
  hello_world: 'Hello World!'
}

export default en;